var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4CCB1F24-6A20-4D18-9C64-01E0317A0D12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-595.000000, -3042.000000)",
    id: "channel_apple"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.000000, 3042.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "BG-1",
    opacity: 0.579999983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5417288,7.08333333 C19.6917288,8.21666668 18.1333946,9.20833347 16.5750612,9.0666668 C16.2917279,7.50833343 17.0000627,6.09166668 17.8500627,4.95833333 C18.8417293,3.82499998 20.4000616,2.975 21.8167283,2.83333333 C22.1000616,4.3916667 21.3917288,5.94999998 20.5417288,7.08333333 Z M28.0500611,24.3666677 C23.6583945,22.6666677 22.9500612,16.4333334 27.3417277,14.1666667 C26.0667278,12.4666666 24.2250624,11.6166664 22.3833958,11.6166664 C21.1083958,11.6166664 20.2583952,11.9000005 19.4083952,12.1833339 C18.7000619,12.4666672 18.1333958,12.6083328 17.4250624,12.6083328 C16.5750624,12.6083328 16.0083946,12.325 15.1583945,12.0416667 C14.3083945,11.7583333 13.4583951,11.4750005 12.4667284,11.4750005 C10.4833951,11.4750005 8.35839503,12.6083328 7.08339506,14.7333328 C5.24172846,17.5666661 5.52506195,23.0916666 8.50006181,27.625 C9.77506178,29.3250001 11.1917279,31.1666667 13.0333945,31.1666667 C13.8833946,31.1666667 14.3083948,30.8833344 14.8750615,30.7416677 C15.5833948,30.4583344 16.2917291,30.1749989 17.4250624,30.1749989 C18.7000624,30.1749989 19.2667294,30.4583344 19.9750627,30.7416677 C20.5417294,31.0250011 20.9667282,31.1666667 21.8167283,31.1666667 C23.8000616,31.1666667 25.2167293,29.0416662 26.3500627,27.4833328 C27.058396,26.3499994 27.4833944,25.6416677 28.0500611,24.3666677 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelApple);
export default __webpack_public_path__ + "static/media/channel_apple.ce11a6644ee25dd33f455897428fc230.svg";
export { ForwardRef as ReactComponent };